/**
 * EntryPoint type
 * DOC: https://schema.org/EntryPoint
 */

export default urlTemplate => ({
  '@type': 'EntryPoint',
  'urlTemplate': urlTemplate
});